var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcEngFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: 7,
    cy: 7,
    r: 7
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 6.65,
    stroke: "#979797",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.835)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#41479B",
    fillRule: "nonzero",
    d: "M20.0748311,4.1734982e-05 L1.62516895,4.1734982e-05 C0.727585742,4.1734982e-05 0,0.716506186 0,1.60036965 L0,12.3996721 C0,13.2834938 0.727585742,14 1.62516895,14 L20.0748311,14 C20.9723719,14 21.7,13.2835355 21.7,12.3996721 L21.7,1.60036965 C21.7,0.716506186 20.9724143,4.1734982e-05 20.0748311,4.1734982e-05 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    fillRule: "nonzero",
    d: "M21.6774947,1.3358116 C21.5494139,0.577946043 20.880825,0 20.0748311,0 L19.6519777,0 L12.7206926,4.47177821 L12.7206926,0 L8.97930742,0 L8.97930742,4.47181994 L2.04802227,0 L1.62516895,0 C0.819175,0 0.150586133,0.577946043 0.0225052734,1.33585333 L5.94669004,5.15794306 L0,5.15794306 L0,8.84214041 L5.94669004,8.84214041 L0.0225052734,12.6641467 C0.150586133,13.4220122 0.819175,13.9999583 1.62516895,13.9999583 L2.04802227,13.9999583 L8.97930742,9.52818006 L8.97930742,13.9999583 L12.7206926,13.9999583 L12.7206926,9.52818006 L19.6519777,13.9999583 L20.0748311,13.9999583 C20.880825,13.9999583 21.5494139,13.422054 21.6774947,12.6641467 L15.75331,8.84205694 L21.7,8.84205694 L21.7,5.15785959 L15.75331,5.15785959 L21.6774947,1.3358116 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF4B55",
    fillRule: "nonzero",
    points: "11.972 0 9.728 0 9.728 5.895 0 5.895 0 8.105 9.728 8.105 9.728 14 11.972 14 11.972 8.105 21.7 8.105 21.7 5.895 11.972 5.895"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF4B55",
    fillRule: "nonzero",
    d: "M1.05079707 13.8967477 8.95870937 8.84205694 7.58431953 8.84205694.390939062 13.4400835C.566954883 13.6423729.793151953 13.8008824 1.05079707 13.8967477ZM14.6808977 8.84205694 13.3065078 8.84205694 20.9657602 13.7377791C21.18009 13.5991772 21.3589455 13.4119541 21.4865178 13.1920942L14.6808977 8.84205694ZM.171608008.884739902 6.85664902 5.15785959 8.23103887 5.15785959.655874023.31576688C.452478906.464844239.286041602.659746609.171608008.884739902ZM14.0950824 5.15785959 21.3016439.551360859C21.1236785.349739156 20.8957014.192147861 20.6362762.0981189447L12.7206926 5.15785959 14.0950824 5.15785959Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEngFlag);
export default __webpack_public_path__ + "static/media/ic_eng_flag.51ebc44c65bfb02ffb3ef2dac86406a7.svg";
export { ForwardRef as ReactComponent };